/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable()
export class MeteostationsApi {
  private readonly apiController: string = 'meteo';

  constructor(private api: HttpService) { }

  getTodayData(params): Observable<any> {
    // console.log('params', params);
    const now = new Date();
    const json = `{"location":
                  {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
                  "device":{"sn":"${params.sn}"},
                  "date":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":${now.getUTCDate()}},
                  "filter":{"orderBy":"ASC"}}`;
    // console.log('json', json);
    const data = JSON.parse(json);
    return this.api.post(`${this.apiController}/byDate`, data);
  }

  getAvgRadiationEnergy(params): Observable<any> {
    // console.log('params', params);
    const now = new Date();
    const json = `{"location":
                  {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
                  "device":{"sn":"${params.sn}"},
                  "date":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":${now.getUTCDate()-1}},
                  "filter":{"orderBy":"ASC"}}`;
    // console.log('json', json);
    const data = JSON.parse(json);
    return this.api.post(`${this.apiController}/radiation`, data);
  }

  getRadiationEnergyByDate(params): Observable<any> {
    console.log('params', params);
    // const now = new Date();
    const json = 
    `{"location": { "name": "${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
      "date": {"y":${params.y},"m":${params.m},"d":${params.d}}
      }`;
    console.log('getRadiationEnergyByDate', 'json', json);
    const data = JSON.parse(json);
    return this.api.post(`${this.apiController}/radiationByDate`, data);
  }  

  list(): Observable<any[]> {
    return this.api.get(this.apiController);
  }
}
